import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@/screens/chat/agents/id/layout';

export const Route = createFileRoute('/_app/_chat/agents/$id')({
  component: LayoutRoute,
});

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
